<template>
            <div id="tickets-app">
               <!-- <vs-sidebar static-position parent="#tickets-app" :hidden-background="true" >
                  <sidebar :totalizadores="totalizadores" :contagemTickets="meta" :filterProgress="filterProgress" :filterType="filterType" @filterTickets="filterTickets" @filterTicketsByType="filterTicketsByType" @filterTicketsById="filterTicketsById"></sidebar>
                </vs-sidebar> -->
                <listview v-on:searching="searchTicket" :onLoad="loading">
                    <!--Totalizador-->
                    <template slot="options-totalizer">
                       <span> Exibindo  {{this.meta.to ? this.meta.to : 0}} de {{this.meta.total}}</span>
                    </template>
                    <!-- Sidebar-->

                    <template slot="sidebar-body">
                        <!--Filtro de tipos-->
                        <div class="email__labels px-6 py-4">
                            <h6 class="mb-8">Tipos de tickets</h6>
                            <div class="flex justify-between items-center cursor-pointer" @click="filterTicketsByType('Bug')">
                                <div class="flex items-center mb-2" :class="{'text-primary':this.filterType.includes('Bug')}">
                                    <vs-checkbox   v-model="tipo_ticket['Bug']"  class="select-all-chexkbox ml-0">
                                        <span class=" ml-3">Bug</span>
                                    </vs-checkbox>
                                </div>
                                <span class="">({{this.totalizadores.tipos["Bug"] > 0 ? this.totalizadores.tipos["Bug"] : 0}})</span>
                            </div>
                            <div class="flex justify-between items-center cursor-pointer" @click="filterTicketsByType('Importação')">
                                <div class="flex items-center mb-2" :class="{'text-primary':this.filterType.includes('Importação')}">
                                    <vs-checkbox   v-model="tipo_ticket['Importação']"  class="select-all-chexkbox ml-0">
                                        <span class=" ml-3">Importação</span>
                                    </vs-checkbox>
                                </div>
                                <span class="">({{this.totalizadores.tipos["Importação"] > 0 ? this.totalizadores.tipos["Importação"] : 0}})</span>
                            </div>
                            <div class="flex justify-between items-center cursor-pointer" @click="filterTicketsByType('Solicitação de Serviço')">
                                <div class="flex items-center mb-2" :class="{'text-primary':this.filterType.includes('Solicitação de Serviço')}">
                                    <vs-checkbox   v-model="tipo_ticket['Solicitação de Serviço']"  class="select-all-chexkbox ml-0">
                                        <span class=" ml-3">Serviço</span>
                                    </vs-checkbox>
                                </div>
                                <span class="">({{this.totalizadores.tipos["Solicitação de Serviço"] > 0 ? this.totalizadores.tipos["Solicitação de Serviço"]: 0}})</span>
                            </div>
                            <div class="flex justify-between items-center cursor-pointer" @click="filterTicketsByType('Melhoria')">
                                <div class="flex items-center mb-2" :class="{'text-primary':this.filterType.includes('Melhoria')}">
                                    <vs-checkbox   v-model="tipo_ticket['Melhoria']"  class="select-all-chexkbox ml-0">
                                        <span class=" ml-3">Melhoria</span>
                                    </vs-checkbox>
                                </div>
                                <span class="">({{this.totalizadores.tipos["Melhoria"]> 0 ? this.totalizadores.tipos["Melhoria"] : 0}})</span>
                            </div>

                        </div>
                        <vs-divider />
                        <!--Filtro de andamento-->
                        <div class="px-6 pb-2 flex flex-col">
                            <h6 class="mb-8">Tipos de andamento</h6>
                            <div class="flex justify-between items-center cursor-pointer" @click="filterTickets('Resolvido')">
                                <div class="flex items-center mb-2" :class="{'text-primary':this.filterProgress.includes('Resolvido')}">
                                    <vs-checkbox   v-model="resolvidos"  class="select-all-chexkbox ml-0">
                                        <span class=" ml-3">Resolvidos</span>
                                    </vs-checkbox>
                                </div>
                                <span class="">({{this.totalizadores.status.resolvidos}})</span>
                            </div>
                            <div class="flex justify-between items-center  cursor-pointer"  @click="filterTickets('Fechado')" :class="{'text-primary':this.filterProgress.includes('Fechado')}">
                                <div class="flex items-center mb-2">
                                    <vs-checkbox  v-model="fechados"  class="select-all-chexkbox ml-0">
                                        <span class=" ml-3">Fechados</span>
                                    </vs-checkbox>
                                </div>
                                <span class="">({{this.totalizadores.status.fechados}})</span>
                            </div>
                            <div class="flex justify-between items-center cursor-pointer" @click="filterTickets('Atribuído')">
                                <div class="flex items-center mb-2" :class="{'text-primary':this.filterProgress.includes('Atribuído')}">
                                    <vs-checkbox   v-model="atribuidos"  class="select-all-chexkbox ml-0">
                                        <span class=" ml-3">Atribuido</span>
                                    </vs-checkbox>
                                </div>
                                <span class="">({{this.totalizadores.status.atribuidos}})</span>
                            </div>
                            <div class="flex justify-between items-center cursor-pointer"  @click="filterTickets('Em desenvolvimento')">
                                <div class="flex items-center mb-2" :class="{'text-primary':this.filterProgress.includes('Em desenvolvimento')}">
                                    <vs-checkbox   v-model="desenvolvimento"  class="select-all-chexkbox ml-0">
                                        <span class=" ml-3">Desenvolvimento</span>
                                    </vs-checkbox>
                                </div>
                                <span class="">({{this.totalizadores.status.desenvolvimento}})</span>
                            </div>
                            <div class="flex justify-between items-center cursor-pointer" @click="filterTickets('Análise de Qualidade')">
                                <div class="flex items-center mb-2" :class="{'text-primary':this.filterProgress.includes('Análise de Qualidade')}">
                                    <vs-checkbox   v-model="analise"  class="select-all-chexkbox ml-0">
                                        <span class=" ml-3">Análise</span>
                                    </vs-checkbox>
                                </div>
                                <span class="">({{this.totalizadores.status.analise}})</span>
                            </div>
                            <div class="flex justify-between items-center cursor-pointer" @click="filterTickets('Em Teste')">
                                <div class="flex items-center mb-2" :class="{'text-primary':this.filterProgress.includes('Em Teste')}">
                                    <vs-checkbox   v-model="teste"  class="select-all-chexkbox ml-0">
                                        <span class=" ml-3">Em Teste</span>
                                    </vs-checkbox>
                                </div>
                                <span class="">({{this.totalizadores.status.teste}})</span>
                            </div>
                            <div class="flex justify-between items-center cursor-pointer" @click="filterTickets('Aguardando Merge')">
                                <div class="flex items-center mb-2" :class="{'text-primary':this.filterProgress.includes('Aguardando Merge')}">
                                    <vs-checkbox   v-model="aguardando"  class="select-all-chexkbox ml-0">
                                        <span class=" ml-3 ">A. Merge</span>
                                    </vs-checkbox>
                                </div>
                                <span class="">({{this.totalizadores.status.aguardando}})</span>
                            </div>
                            <div class="flex justify-between items-center cursor-pointer" @click="filterTickets('Merge Master')">
                                <div class="flex items-center mb-2" :class="{'text-primary':this.filterProgress.includes('Merge Master')}">
                                    <vs-checkbox   v-model="merge" class="select-all-chexkbox ml-0">
                                        <span class=" ml-3">Merge Master</span>
                                    </vs-checkbox>
                                </div>
                                <span class="">({{this.totalizadores.status.merge}})</span>
                            </div>
                        </div>

                    </template>
                    <template slot="sidebar-footer">
                        <vs-button color="primary" type="filled" @click="clearFilters()">Limpar Filtros</vs-button>
                    </template>
                    <!--Tabela-->
                    <template slot="container-body">
                        <div class=" h-full w-full overflow-auto" @scroll.passive="handleScroll">
                            <vs-table :data="tickets" stripe >
                                <template slot="thead" >
                                    <vs-th>
                                        <span class="sort-th">
                                            <i @click="sortTicketsMiddleware({orderBy: 'id_ticket', sort: 'desc'})" class="material-icons up-sort" >
                                                expand_less
                                            </i>
                                            <i @click="sortTicketsMiddleware({orderBy: 'id_ticket', sort: 'asc'})" class="material-icons down-sort" >
                                                expand_more
                                            </i>
                                        </span>
                                        #
                                    </vs-th>
                                    <vs-th>
                                        <span class="sort-th">
                                            <i @click="sortTicketsMiddleware({orderBy: 'relatado_por_nome', sort: 'desc'})" class="material-icons up-sort" >
                                                expand_less
                                            </i>
                                            <i @click="sortTicketsMiddleware({orderBy: 'relatado_por_nome', sort: 'asc'})" class="material-icons down-sort" >
                                                expand_more
                                            </i>
                                        </span>
                                        Relator
                                    </vs-th>
                                    <vs-th>
                                        <span class="sort-th">
                                            <i @click="sortTicketsMiddleware({orderBy: 'resumo', sort: 'desc'})" class="material-icons up-sort" >
                                                expand_less
                                            </i>
                                            <i @click="sortTicketsMiddleware({orderBy: 'resumo', sort: 'asc'})" class="material-icons down-sort" >
                                                expand_more
                                            </i>
                                        </span>
                                        Resumo
                                    </vs-th>
                                    <vs-th>
                                        <span class="sort-th">
                                            <i @click="sortTicketsMiddleware({orderBy: 'observacao', sort: 'desc'})" class="material-icons up-sort" >
                                                expand_less
                                            </i>
                                            <i @click="sortTicketsMiddleware({orderBy: 'observacao', sort: 'asc'})" class="material-icons down-sort" >
                                                expand_more
                                            </i>
                                        </span>
                                        Resposta
                                    </vs-th>
                                    <vs-th>
                                        <span class="sort-th">
                                            <i @click="sortTicketsMiddleware({orderBy: 'data_hora_cadastro', sort: 'desc'})" class="material-icons up-sort" >
                                                expand_less
                                            </i>
                                            <i @click="sortTicketsMiddleware({orderBy: 'data_hora_cadastro', sort: 'asc'})" class="material-icons down-sort" >
                                                expand_more
                                            </i>
                                        </span>
                                        Cadastro
                                    </vs-th>
                                    <vs-th>
                                        <span class="sort-th">
                                            <i @click="sortTicketsMiddleware({orderBy: 'andamento', sort: 'desc'})" class="material-icons up-sort" >
                                                expand_less
                                            </i>
                                            <i @click="sortTicketsMiddleware({orderBy: 'andamento', sort: 'asc'})" class="material-icons down-sort" >
                                                expand_more
                                            </i>
                                        </span>
                                        Andamento
                                    </vs-th>
                                    <vs-th>
                                        <span class="sort-th">
                                            <i @click="sortTicketsMiddleware({orderBy: 'tipo_nome', sort: 'desc'})" class="material-icons up-sort" >
                                                expand_less
                                            </i>
                                            <i @click="sortTicketsMiddleware({orderBy: 'tipo_nome', sort: 'asc'})" class="material-icons down-sort" >
                                                expand_more
                                            </i>
                                        </span>
                                        Tipo
                                    </vs-th>
                                    <vs-th>Solicitantes</vs-th>
                                </template>
                                <template slot-scope="{data}">
                                    <vs-tr :key="idx" v-for="(tr, idx) in data">

                                        <vs-td>
                                            {{tr.id_ticket}}
                                        </vs-td>

                                        <vs-td>
                                            {{tr.relatado_por_nome}}
                                        </vs-td>

                                        <vs-td>
                                            {{tr.resumo}}
                                        </vs-td>

                                        <vs-td v-html="tr.observacao">
                                        </vs-td>

                                        <vs-td>
                                            {{tr.data_cadastro}}
                                        </vs-td>

                                        <vs-td :class="{
                                                'text-success': tr.andamento === 'Resolvido',
                                                'text-danger': tr.andamento === 'Fechado',
                                                'text-primary': !['Resolvido','Fechado'].includes(tr.andamento)
                                            }">
                                            {{tr.andamento}}
                                        </vs-td>

                                        <vs-td>
                                            {{tr.tipo}}
                                        </vs-td>

                                        <vs-td>
                                            {{tr.solicitantes}}
                                        </vs-td>

                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                    </template>
                </listview>
            </div>
</template>

<script>
    import {debounce} from "lodash";
    import ListView from "../components/list-view/list-view.vue";
    export default {
        components:{
            'listview':ListView
        },
        data() {
            return {
                search: '',
                teste:false,
                merge:false,
                aguardando:false,
                analise:false,
                atribuidos:false,
                desenvolvimento:false,
                fechados:false,
                resolvidos:false,
                filterType:[],
                filterProgress:[],
                loading: true,
                totais_tipos:[],
                tipo_ticket:[
                    {"Bug":false},
                    {"Importação":false},
                    {"Melhoria":false},
                    {"Solicitação de Serviço":false}
                ],
                tickets: [],
                meta: {
                    total: 0,
                    current_page: 1,
                    last_page: 1,
                    to:0
                },
                totalizadores: {
                    tipos: [],
                    status: {
                        resolvidos: 0,
                        fechados: 0,
                        desenvolvimento: 0,
                        analise:0,
                        teste:0,
                        aguardando:0,
                        merge:0,
                        atribuidos:0
                    }
                },
                ticketTags:[
                    {
                        "text":"Bug",
                        "color":"red"
                    },
                    {
                        "text":"Importação",
                        "color":"blue"
                    },
                    {
                        "text":"Melhoria",
                        "color":"green"
                    },
                    {
                        "text":"Solicitação de Serviço",
                        "color":"yellow"
                    }
                ],
                sort: {
                    orderBy: null,
                    sort: null
                }
            }
        },
        methods: {

            sortTicketsMiddleware (sort) {
                this.meta = {
                    total: 0,
                    current_page: 1,
                    last_page: 1,
                    to:0
                };
                this.sort = sort;

                if(this.search=="" && (this.filterProgress.length > 0 || this.filterType.length > 0)){
                    this.filterTickets("",this.meta.current_page);
                }else{
                    if(this.search==""){
                        this.getTickets('',this.meta.current_page, sort);
                    }
                    if(this.search!=""){
                        this.searchTicket(this.search, this.meta.current_page);
                    }
                }
            },

             /**
              Busca de tickets sem nenhum filtro ativo.
             */
            async getTickets(query = '', page = 1, sort = {orderBy: null, sort: null}) {
                this.loading = true;
                const {data: {data, meta}} = await this.$axios.get(`stats/tickets`, {
                    params: {
                        query,
                        page,
                        orderBy: sort.orderBy,
                        direction: sort.sort
                    }
                });
                this.meta = meta;
                if (page === 1) {
                    await this.getTotalizadores(query);
                    this.tickets = data;
                } else {
                    this.tickets = this.tickets.concat(data);
                }
                this.loading = false;
            },
            /**
              Limpa os filtros de tipo e andamento.
             */
            clearFilters(){
                this.teste = false;
                this.merge = false;
                this.aguardando = false;
                this.analise = false;
                this.atribuidos = false;
                this.desenvolvimento = false;
                this.fechados = false;
                this.resolvidos = false;
                this.filterProgress = [];
                this.filterType = [];
                this.tipo_ticket["Bug"] = false;
                this.tipo_ticket["Importação"] = false;
                this.tipo_ticket["Melhoria"] = false;
                this.tipo_ticket["Solicitação de Serviço"] = false;
                this.getTickets('');
            },
            async getTotalizadores(query,tipos=null) {
                tipos = tipos != null ? JSON.stringify(tipos):null;
                const {data} = await this.$axios.get(`stats/tickets/totals`, { params: { query,tipos } });
                if(tipos != null){
                    this.totalizadores.status = data.status;
                    this.totalizadores.tipos = this.totais_tipos;

                }else{
                     Object.keys(data.tipos).map(function(key){
                      data.tipos["key"] = key;
                    });
                    this.totalizadores = data;
                    this.totais_tipos = data.tipos;

                }


            },
             /**
              Busca os tickets de acordo com a caixa de busca
             */
            searchTicket: _.debounce(async function(search,page=1){
                this.search = search;
                if(search!=""){
                    this.loading=true;
                    let andamentos = JSON.stringify(this.filterProgress);
                    let tipos = JSON.stringify(this.filterType);
                    const {data: {data,meta} } = await this.$axios.get(`stats/tickets/search`, { params: {page, search, tipos, andamentos, ...this.sort } });
                    this.meta = meta;
                    if(page==1){
                        this.tickets = data;
                    }else{
                        this.tickets = this.tickets.concat(data);
                    }
                    this.loading=false;
                }else{
                    this.filterTickets('');
                }
            }, 1200),
             /**
               Busca os tickets de acordo com os filtros de andamento e tipo
             */
            async filterTickets(filtro,page = 1){
                //adiciona ou remove o andamento do array de filtros de andamento
                this.filterProgress.includes(filtro)  ?
                ( this.filterProgress.splice(this.filterProgress.indexOf(filtro),1)) :
                (filtro!="") && this.filterProgress.push(filtro);
                //se os dois arrays de filtros estiverem vazios então retorna todos os dados
                if(this.filterProgress.length == 0 && this.filterType.length==0 && this.search==""){
                    this.getTickets();
                    return;
                }

                if(this.search!=""){
                    this.searchTicket(this.search);
                    return;
                }else{
                    let andamentos = JSON.stringify(this.filterProgress);
                    let tipos = JSON.stringify(this.filterType);
                    this.loading = true;
                    const {data:{data,meta}} = await this.$axios.get(`stats/tickets/filters`, { params: {andamentos, tipos, page, ...this.sort} });
                    this.meta= meta;
                    if(page==1){
                        this.tickets = data;
                    }else{
                        this.tickets = this.tickets.concat(data);
                    }
                    this.loading = false;
                }
            },
             /**
              Altera o array de filtros de tipos e chama a função que busca os tickets no banco.
             */
            async filterTicketsByType(filtro){
                //adiciona ou remove o tipo do array de filtros de tipos
                this.filterType.includes(filtro) ?
                 ( this.filterType.splice(this.filterType.indexOf(filtro),1)) :
                 (filtro!="") && this.filterType.push(filtro);
                //se os dois arrays de filtros estiverem vazios então retorna todos os dados
                if(this.filterProgress.length == 0 && this.filterType.length==0 && this.search==""){
                     this.getTickets();
                     return;
                }
                this.filterTickets('');
                this.getTotalizadores('',this.filterType);
            },
            getColor(type){
                let color = this.ticketTags.filter((tag)=>{
                    return tag.text==type;
                });
                return color[0]["color"];
            },
            /**
             * Responsável pela paginação dos tickets quando alcança o fim da página
             */
            handleScroll: debounce(function (e) {
               const el = e.target.documentElement || e.target;
               let windowRelativeBottom = el.scrollHeight - el.offsetHeight;
                if ((el.scrollTop > windowRelativeBottom - 50) && this.meta.current_page !== this.meta.last_page) {
                    if(this.search=="" && (this.filterProgress.length > 0 || this.filterType.length > 0)){
                        this.filterTickets("",this.meta.current_page + 1);
                    }else{
                        if(this.search==""){
                            this.getTickets('',this.meta.current_page + 1, this.sort);
                        }
                        if(this.search!=""){
                            this.searchTicket(this.search,this.meta.current_page + 1);
                        }
                    }
                }

            }, 1000),
        },
        created() {
            this.getTickets();
        },
        mounted() {
            window.document.body.addEventListener('scroll', this.handleScroll);
        },
        beforeDestroy() {
            window.document.body.removeEventListener('scroll', this.handleScroll);
        },
        events:{

        }
    }
</script>
<style lang="scss">
    .app-fixed-height{
        height: calc(100vh - 18rem);
    }

</style>
